import React, {useState} from 'react'
import {Link} from 'gatsby'
import * as styles from './navigation.module.css'
import {Helmet} from "react-helmet";
import {MenuIcon} from "./icons";
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {navigate} from "gatsby-link";

const langMap = {
  en: 'English',
  ar: 'عربى'
}

const LANGNAVMAP = {
  home: {
    en: 'Home',
    ar: 'الصفحة الرئيسية'
  },
  product: {
    en: 'Product line',
    ar: 'خط الإنتاج'
  },
  aboutus: {
    en: 'About us',
    ar: 'معلومات عنا'
  },
  contactus: {
    en: 'Contact us',
    ar: 'اتصل بنا'
  },
  blogs: {
    en: 'Blogs',
    ar: 'المدونات'
  }
}

export default ({location, langs, currentLang}) => {
  const [currentLangInfo] = useState(currentLang === 'en' ? '' : `/${currentLang}`)
  const isActiveRoute = (path) => {
    if (path === '/' && !location.hash) {
      return location.pathname === '/'
    } else {
      return location.pathname.includes(path) || location.hash.includes(path)
    }
  }

  const handleChangeLang = (lang) => {
    navigate(lang, { replace: true })
  }

  return (
    <Navbar collapseOnSelect expand="lg" style={{background: 'var(--main-color)', color: 'var(--font-main-color)'}}>
        <Navbar.Brand href="/">
          <img style={{height: 40}}
               src="data:image/png;base64,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"
               className={styles.logo} alt="logo"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav"><MenuIcon /></Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto"/>
          <Nav className='px-3 px-lg-3 px-md-3 px-xl-5 py-1'>
            <Link to={`${currentLangInfo}/`}>{LANGNAVMAP.home[currentLang]}</Link>
          </Nav>
          <Nav className='px-3 px-lg-3 px-md-3 px-xl-5 py-1'>
            <Link to={`${currentLangInfo}/product-line`}>{LANGNAVMAP.product[currentLang]}</Link>
          </Nav>
          <Nav className='px-3 px-lg-3 px-md-3 px-xl-5 py-1'>
            <Link to={`${currentLangInfo}/about-us`}>{LANGNAVMAP.aboutus[currentLang]}</Link>
          </Nav>
          <Nav className='px-3 px-lg-3 px-md-3 px-xl-5 py-1'>
            <Link to={`${currentLangInfo}/contact-us`}>{LANGNAVMAP.contactus[currentLang]}</Link>
          </Nav>
          <Nav className='px-3 px-lg-3 px-md-3 px-xl-5 py-1'>
            <Link to={`${currentLangInfo}/blogs`}>{LANGNAVMAP.blogs[currentLang]}</Link>
          </Nav>
          <Nav className='px-3 px-lg-3 px-md-3 px-xl-5 py-1'>
            {
              langs.map((lang, index) => {
                return (
                  <a onClick={() => handleChangeLang(lang.link)} className={styles.lang} key={lang.langKey}>
                      <span selected={lang.selected} className='d-inline-block' style={{width: 80}}>
                        {langMap[lang.langKey]} {(index + 1) === langs.length ? '' : "|"}
                      </span>
                  </a>
                )
              })
            }
          </Nav>
        </Navbar.Collapse>
    </Navbar>
  )
}
